var _style, _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 18.9",
    style: {
      enableBackground: "new 0 0 20.3 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;}\r\n\t.st2{fill:#E2E2E2;stroke:#FFFFFF;stroke-width:2;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,11h12.8c1,0,1.8,0.8,1.8,1.8v2.7c0,1-0.8,1.8-1.8,1.8H3.7c-1,0-1.8-0.8-1.8-1.8v-2.7 C1.9,11.8,2.7,11,3.7,11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,1.4H3.7c-1,0-1.8,0.8-1.8,1.8V6c0,1,0.8,1.8,1.8,1.8h4.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 14.6,
    cy: 4.6,
    r: 3.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 14.6,
    cy: 4.6,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.412456080415d6cb037b0021d128335f.svg";
export { ForwardRef as ReactComponent };